import { BREAK_POINTS } from 'helpers/media/media.constants';
import { TBreakpoints } from './theme.types';

const BREAKPOINTS: TBreakpoints = [
  BREAK_POINTS.xSmall,
  BREAK_POINTS.small,
  BREAK_POINTS.medium,
  BREAK_POINTS.large,
  BREAK_POINTS.xLarge,
];

const [xs, s, m, l, xl] = BREAKPOINTS;

BREAKPOINTS.xs = xs;
BREAKPOINTS.s = s;
BREAKPOINTS.m = m;
BREAKPOINTS.l = l;
BREAKPOINTS.xl = xl;

export default BREAKPOINTS;
